import React from 'react';

export function FilterIcon () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
    >
      <circle cx="18" cy="18" r="18" fill="#F8F8F8" />
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22 17.015V10.89M22 25.111v-2.99"
      />
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M24.222 19.333A2.222 2.222 0 1122 17.111v0c1.227 0 2.222.995 2.222 2.222v0z"
        clipRule="evenodd"
      />
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 15.334v9.777"
      />
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.222 13.111a2.222 2.222 0 10-4.444 0 2.222 2.222 0 004.444 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
